export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="inline-block font-heading text-2xl text-primary-400 mb-4">
              51动漫
            </a>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              51动漫官网是集51动漫网与51动漫网站于一体的国产动漫精品入口平台，为动漫爱好者提供快速、安全、全面的官方直达服务。每日更新热门番剧，追踪行业动态，致力于打造国产动漫领域最具影响力的导航门户。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-qq-line text-sm"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</a></li>
              <li><a href="#carousel" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">焦点专题</a></li>
              <li><a href="#ranking" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">热度榜</a></li>
              <li><a href="#cards" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">动漫推荐</a></li>
              <li><a href="#about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">资源分类</h4>
            <ul className="space-y-2.5">
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">玄幻修仙</a></li>
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">热血战斗</a></li>
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">科幻未来</a></li>
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">武侠江湖</a></li>
              <li><a href="#topics" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">搞笑日常</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-400">合作站点即将入驻</span></li>
              <li><span className="text-sm text-foreground-400">商务合作请联系</span></li>
            </ul>
            <a href="#contact" className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
              <i className="ri-service-line"></i>
              合作联系
            </a>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 md:mt-12 pt-6 md:pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 51动漫官网. 51动漫网与51动漫网站国产精品入口. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">常见问题</a>
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">联系我们</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}